// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { OfferingPackageImageOfferingPackageFragmentDoc } from './OfferingPackageImage.generated';
export type OfferingPackageCardCoachFragment = {
  __typename?: 'Coach';
  id: string;
  tier: Types.SkuTier;
};

export type OfferingPackageCardOfferingPackageFragment = {
  __typename?: 'OfferingPackage';
  id: string;
  slug?: string | null;
  name: string;
  subTitle?: string | null;
  isUniversalPackage: boolean;
  imageLink?: string | null;
  prices?: Array<{
    __typename?: 'OfferingPackagePrice';
    sku?: string | null;
    price: number;
    packageCoachingTime?: {
      __typename?: 'PackageCoachingTime';
      exactTimeInMinute?: number | null;
      estimate?: {
        __typename?: 'IntRange';
        start?: number | null;
        end?: number | null;
      } | null;
    } | null;
  }> | null;
  category?: { __typename?: 'Category'; id: string; slug: string } | null;
  coach: { __typename?: 'Coach'; id: string; slug: string };
};

export const OfferingPackageCardCoachFragmentDoc = gql`
  fragment OfferingPackageCard_Coach on Coach {
    id
    tier
  }
`;
export const OfferingPackageCardOfferingPackageFragmentDoc = gql`
  fragment OfferingPackageCard_OfferingPackage on OfferingPackage {
    id
    slug
    name
    subTitle
    prices {
      sku
      price
      packageCoachingTime {
        estimate {
          start
          end
        }
        exactTimeInMinute
      }
    }
    category {
      id
      slug
    }
    coach {
      id
      slug
    }
    isUniversalPackage
    ...OfferingPackageImage_OfferingPackage
  }
  ${OfferingPackageImageOfferingPackageFragmentDoc}
`;
